<table class="search-table">
    <thead>
        <tr>
            <td></td>
            <td *ngFor="let frequency of frequencyItems">{{frequency}}</td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>AC</td>
            <td *ngFor="let ac of graphModel.acValues">{{getCellText(ac)}}</td>
        </tr>
        <tr>
            <td>BC</td>
            <td *ngFor="let bc of graphModel.bcValues">{{getCellText(bc)}}</td>
        </tr>
        <tr>
            <td>MCL</td>
            <td *ngFor="let mcl of graphModel.mclValues">{{getCellText(mcl)}}</td>
        </tr>
        <tr>
            <td>UCL</td>
            <td *ngFor="let ucl of graphModel.uclValues">{{getCellText(ucl)}}</td>
        </tr>
        <tr>
            <td>SF</td>
            <td *ngFor="let sf of graphModel.sfValues">{{getCellText(sf)}}</td>
        </tr>
        <tr>
            <td>SF-A</td>
            <td *ngFor="let sfa of graphModel.sfaValues">{{getCellText(sfa)}}</td>
        </tr>
    </tbody>
</table>